import styled from 'styled-components';

const LandingModalReminderText = styled.div`
  font-size: 16px;
  text-align: center;
  color: #001246;
  margin: 24px 18px 26px;
`;

export default LandingModalReminderText;
